import { useQueryCache, useMutation } from "react-query";
import { useSelector } from "react-redux";
import network from "../../../../../selectors/network";
import putPublicInspectionRequest, {
  InspectionsRequestUpdateReqBody,
} from "../../../api/inspections/public/putPublicInspectionRequest";
import { PublicInspectionQueryKey } from "./usePublicInspection";
import { PublicInspectionsQueryKey } from "./usePublicInspections";

interface IParams {
  id: string | number;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}
export default function usePublicInspectionRequestMutation({ id, onSuccess, onError }: IParams) {
  const queryCache = useQueryCache();
  const networkHeaders = useSelector(network.defaultHeaders);

  const [inspectionRequestMutation, inspectionRequestMutationState] = useMutation(
    putPublicInspectionRequest(networkHeaders, Number(id)),
    {
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
        const publicInspectionsKey = PublicInspectionQueryKey();
        queryCache.invalidateQueries(publicInspectionsKey);
        const publicInspectionsListKey = PublicInspectionsQueryKey();
        queryCache.invalidateQueries(publicInspectionsListKey);
      },
      onError: (error: unknown) => {
        if (onError) {
          onError(error);
        }
      },
    },
  );

  return {
    updateInspectionRequest: (data: InspectionsRequestUpdateReqBody) => {
      inspectionRequestMutation(data);
    },
    isLoading: inspectionRequestMutationState.isLoading,
  };
}
